import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import { AddCircleOutlineRounded, Delete } from "@mui/icons-material";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { IconButton, TextField } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DoneIcon from "@mui/icons-material/Done";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { toast } from "react-toastify";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";
import { CACHE_KEY } from "../constant/cache-key";

export default function Menu({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [data, setData] = useState([]);
  const [OGdata, setOGData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openAdd, setOpenAdd] = useState([]);
  const [inputV, setInputV] = useState([]);
  const [subOpenAdd, setSubOpenAdd] = useState([]);
  const [subInputV, setSubInputV] = useState([]);
  const [openSubMenuIdx, setOpenSubMenuIdx] = useState(null);
  const [itemEditible, setItemEditible] = useState({});
  const [subItemEditible, setSubItemEditible] = useState({});
  const [editibleImage, setEditibleImage] = useState();
  const subMenuRefs = useRef([]);
  const fileInputRef = useRef(null);
  const hiddenFileInput = useRef();
  const formData = new FormData();
  const subFormData = new FormData();

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setEditibleImage(file);
    }
  };

  const toggleSubMenu = (idx) => {
    setOpenSubMenuIdx(openSubMenuIdx === idx ? null : idx);
  };

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  const handleIconInput = (e, index) => {
    const file = e.target.files[0];

    if (file) {
      setInputV([
        ...inputV.map((item, idx) => {
          if (idx === index) {
            return {
              ...item,
              icon: file,
            };
          } else {
            return item;
          }
        }),
      ]);
    }
  };

  const handleSubIconInput = (e, index) => {
    const file = e.target.files[0];

    if (file) {
      setSubInputV([
        ...subInputV.map((item, idx) => {
          if (idx === index) {
            return {
              ...item,
              icon: file,
            };
          } else {
            return item;
          }
        }),
      ]);
    }
  };

  // Get Data from backend
  useEffect(() => {
    let docs = langs.map((item) => ({
      menu: [],
      language: item.attributes.language,
    }));
    setData(docs);
    setOGData(docs);
    let errorDocs = [];
    langs.map(() => {
      errorDocs.push({ error: false });
    });
    setErrors(errorDocs);
    let openDocs = [];
    langs.map(() => {
      openDocs.push({ open: false });
    });
    setOpenAdd(openDocs);
    let subOpenDocs = [];
    langs.map(() => {
      subOpenDocs.push({ open: false });
    });
    setSubOpenAdd(subOpenDocs);
    let inputVDocs = [];
    langs.map(() => {
      inputVDocs.push({ title: "", description: "", url: "", icon: "" });
    });
    setInputV(inputVDocs);
    let subInputVDocs = [];
    langs.map(() => {
      subInputVDocs.push({ title: "", description: "", url: "", icon: "" });
    });
    setSubInputV(subInputVDocs);

    async function getData() {
      await fetch(`${API}/menu`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.menuData || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find(
              (apiItem) => apiItem.language === localItem.language
            );

            if (apiItem) {
              return {
                ...localItem,
                menu: apiItem.menu || localItem.menu,
              };
            } else {
              return localItem;
            }
          });
        });
        setOGData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find(
              (apiItem) => apiItem.language === localItem.language
            );

            if (apiItem) {
              return {
                ...localItem,
                menu: apiItem.menu || localItem.menu,
              };
            } else {
              return localItem;
            }
          });
        });
        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const submitData = (item, index) => {
    fetch(`${API}/menu`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { menuData: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  const onDragEnd = (result, index) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) return;

    const items = Array.from(data[index].menu);
    const [reorderedItem] = items.splice(source.index, 1);
    items.splice(destination.index, 0, reorderedItem);

    setData((prevData) =>
      prevData.map((item, idx) =>
        idx === index ? { ...item, menu: items } : item
      )
    );
    setOGData((prevData) =>
      prevData.map((item, idx) =>
        idx === index ? { ...item, menu: items } : item
      )
    );
  };

  const onSubDragEnd = (result, index, idx) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) return;

    // Create a copy of the nested array to work with
    const nestedMenuItems = Array.from(data[index].menu);
    const items = Array.from(nestedMenuItems[idx].dropDownItems);

    // Remove the item from the source index
    const [reorderedItem] = items.splice(source.index, 1);

    // Insert the item at the destination index
    items.splice(destination.index, 0, reorderedItem);

    // Update the nested structure in the state
    setData((prevData) =>
      prevData.map((item, i) =>
        i === index
          ? {
            ...item,
            menu: nestedMenuItems.map((nestedItem, j) =>
              j === idx ? { ...nestedItem, dropDownItems: items } : nestedItem
            ),
          }
          : item
      )
    );
    setOGData((prevData) =>
      prevData.map((item, i) =>
        i === index
          ? {
            ...item,
            menu: nestedMenuItems.map((nestedItem, j) =>
              j === idx ? { ...nestedItem, dropDownItems: items } : nestedItem
            ),
          }
          : item
      )
    );
  };

  const addNewMenuItem = (index) => {
    formData.append("files", inputV[index].icon, inputV[index].icon?.name);

    fetch(`${API}/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      body: formData,
    }).then(async (res) => {
      const response = await res.json();
      const iconURL = response[0]?.url;
      let tempData = data;

      tempData[index]?.menu.push({
        title:
          inputV[index]?.title.charAt(0).toUpperCase() +
          inputV[index]?.title.slice(1),
        description:
          inputV[index]?.description.charAt(0).toUpperCase() +
          inputV[index]?.description.slice(1),
        icon: iconURL,
        url: inputV[index]?.url,
        dropDownItems: [],
      });

      fetch(`${API}/menu`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: { menuData: tempData },
        }),
      }).then(async (res) => {
        if (res.ok) {
          setData(tempData);
          setSuccess(true);
          setInputV([
            ...inputV.map((item, idx) => {
              if (idx === index) {
                return {
                  ...item,
                  title: "",
                  description: "",
                  url: "",
                  icon: "",
                };
              } else {
                return item;
              }
            }),
          ]);
          setOpenAdd([
            ...openAdd.map((item, idx) => {
              if (idx === index) {
                return { ...item, open: false };
              } else {
                return item;
              }
            }),
          ]);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        } else {
          setFail(true);
        }
      });
    });
  };

  const deleteMenuItem = (index, idx) => {
    let tempData = data;
    let filteredData = tempData[index]?.menu.filter((item, i) => i !== idx);

    tempData[index] = {
      ...tempData[index],
      menu: filteredData,
    };

    setData(tempData);

    fetch(`${API}/menu`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { menuData: tempData },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  const editMenuItem = (index, idx) => {
    setData(OGdata);
    setSubItemEditible({});

    const item = {
      index,
      idx,
    };
    setEditibleImage(null);

    if (itemEditible.index === index && itemEditible.idx === idx) {
      setItemEditible({});
    } else {
      setItemEditible(item);
    }
  };

  const editSubMenuItem = (index, idx, ndx) => {
    setData(OGdata);
    setItemEditible({});
    const item = {
      index,
      idx,
      ndx,
    };
    setEditibleImage(null);

    if (
      subItemEditible.index === index &&
      subItemEditible.idx === idx &&
      subItemEditible.ndx === ndx
    ) {
      setSubItemEditible({});
    } else {
      setSubItemEditible(item);
    }
  };

  const doneeditingMenuItem = (index, idx) => {
    const editForm = new FormData();

    if (editibleImage) {
      editForm.append("files", editibleImage);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: editForm,
      }).then(async (res) => {
        const response = await res.json();
        const iconURL = response[0]?.url;

        const updatedMenuData = [...data];

        const currentItem = updatedMenuData[index].menu[idx];

        updatedMenuData[index].menu[idx] = {
          ...currentItem,
          icon: iconURL,
        };

        fetch(`${API}/menu`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify({
            data: { menuData: updatedMenuData },
          }),
        }).then((res) => {
          if (res.ok) {
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          }
        });

        setData(updatedMenuData);
        setOGData(updatedMenuData);
        if (hiddenFileInput.current) {
          hiddenFileInput.current.value = "";
        }
        setItemEditible({});
      });
    } else {
      fetch(`${API}/menu`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: { menuData: data },
        }),
      }).then((res) => {
        if (res.ok) {
          setOGData(data);
          toast("Updated Successfully", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "success",
          });
        }
      });
      setItemEditible({});
      setSubItemEditible({});
    }
  };
  const doneeditingMenuSubItem = (index, idx, ndx) => {
    const editForm = new FormData();

    if (editibleImage) {
      editForm.append("files", editibleImage);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: editForm,
      }).then(async (res) => {
        const response = await res.json();
        const iconURL = response[0]?.url;

        const updatedMenuData = [...data];

        const currentItem = updatedMenuData[index].menu[idx].dropDownItems[ndx];

        updatedMenuData[index].menu[idx].dropDownItems[ndx] = {
          ...currentItem,
          icon: iconURL,
        };

        fetch(`${API}/menu`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify({
            data: { menuData: updatedMenuData },
          }),
        }).then((res) => {
          if (res.ok) {
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          }
        });

        setData(updatedMenuData);
        setOGData(updatedMenuData);
        if (hiddenFileInput.current) {
          hiddenFileInput.current.value = "";
        }
        setSubItemEditible({});
      });
    } else {
      fetch(`${API}/menu`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: { menuData: data },
        }),
      }).then((res) => {
        if (res.ok) {
          setOGData(data);
          toast("Updated Successfully", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            type: "success",
          });
        }
      });

      setSubItemEditible({});
    }
  };

  const addNewSubMenuItem = (index, idx) => {
    subFormData.append(
      "files",
      subInputV[index].icon,
      subInputV[index].icon?.name
    );

    fetch(`${API}/upload`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      body: subFormData,
    }).then(async (res) => {
      const response = await res.json();
      const iconURL = response[0]?.url;
      let tempData = data;

      tempData[index]?.menu[idx]?.dropDownItems?.push({
        title: subInputV[index]?.title,
        description: subInputV[index]?.description,
        url: subInputV[index]?.url,
        icon: iconURL,
      });

      fetch(`${API}/menu`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: { menuData: tempData },
        }),
      }).then(async (res) => {
        if (res.ok) {
          setData(tempData);
          setSuccess(true);
          setSubInputV([
            ...subInputV.map((item, idx) => {
              if (idx === index) {
                return {
                  ...item,
                  title: "",
                  description: "",
                  url: "",
                  icon: "",
                };
              } else {
                return item;
              }
            }),
          ]);
          setSubOpenAdd([
            ...subOpenAdd.map((item, idx) => {
              if (idx === index) {
                return { ...item, open: false };
              } else {
                return item;
              }
            }),
          ]);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        } else {
          setFail(true);
        }
      });
    });
  };

  const deleteSubMenuItem = (index, idx, ndx) => {
    const updatedData = [...data];

    if (
      updatedData[index] &&
      updatedData[index].menu &&
      updatedData[index].menu[idx] &&
      updatedData[index].menu[idx].dropDownItems
    ) {
      updatedData[index].menu[idx].dropDownItems = updatedData[index].menu[
        idx
      ].dropDownItems.filter((item, i) => i !== ndx);

      setData(updatedData);

      fetch(`${API}/menu`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
        body: JSON.stringify({
          data: { menuData: updatedData },
        }),
      }).then(async (res) => {
        if (res.ok) {
          setSuccess(true);
        } else {
          setFail(true);
        }
      });
    }
  };

  return (
    <TabContext value={value}>

      <Box mt={2}>
        <ClearCacheButton
          keys={[
            CACHE_KEY.startupConfigs
          ]} />
      </Box>

      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>Menu Settings</h3>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs"
        >
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={
                      SERVER_DOMAIN + item.attributes.icon.data.attributes.url
                    }
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                  <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
                  <div>
                    <DragDropContext
                      onDragEnd={(result) => onDragEnd(result, index)}
                    >
                      <Droppable
                        droppableId={`menu-${index}`}
                        key={`droppable-${index}`}
                      >
                        {(provided) => (
                          <ul
                            style={{ padding: 0, marginTop: 0, width: "50%" }}
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                          >
                            {data[index]?.menu.map((item, idx) => (
                              <Draggable
                                key={`item-key-${idx + 40 * 70}`}
                                draggableId={`item-key-${idx + 40 * 8}`}
                                index={idx}
                              >
                                {(provided) => (
                                  <li
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <div
                                      className="menu-b-i"
                                      style={{
                                        height:
                                          itemEditible.index == index &&
                                            itemEditible.idx == idx
                                            ? 140
                                            : 50,
                                      }}
                                    >
                                      <DragIndicatorIcon
                                        style={{ color: "#777" }}
                                      />
                                      <div
                                        className="group relative"
                                        style={{
                                          width:
                                            itemEditible.index == index &&
                                              itemEditible.idx == idx
                                              ? 65
                                              : 25,
                                          transition: "0.2s",
                                        }}
                                        onClick={() => {
                                          if (
                                            itemEditible.index == index &&
                                            itemEditible.idx == idx
                                          ) {
                                            hiddenFileInput.current.click();
                                          }
                                        }}
                                      >
                                        <img
                                          style={{
                                            width: "100%",
                                            aspectRatio: 1,
                                            borderRadius: 55,
                                            objectFit: "cover",
                                            transition: "0.2s",
                                          }}
                                          src={
                                            itemEditible.index == index &&
                                              itemEditible.idx == idx
                                              ? editibleImage
                                                ? URL.createObjectURL(
                                                  editibleImage
                                                )
                                                : SERVER_DOMAIN +
                                                data[index]?.menu[idx]?.icon
                                              : SERVER_DOMAIN +
                                              data[index]?.menu[idx]?.icon
                                          }
                                        />

                                        <div
                                          style={{
                                            display:
                                              itemEditible.index == index &&
                                                itemEditible.idx == idx
                                                ? "flex"
                                                : "none",
                                          }}
                                          className="group absolute top-0 left-0 w-full rounded-full h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center"
                                        >
                                          <CameraAltIcon
                                            size="small"
                                            className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                                          />
                                        </div>
                                      </div>
                                      <div>
                                        {itemEditible.index == index &&
                                          itemEditible.idx == idx ? (
                                          <TextField
                                            variant="outlined"
                                            size="small"
                                            sx={{ mb: 1 }}
                                            inputProps={{
                                              style: { fontSize: 14 },
                                            }}
                                            value={item.title || ""}
                                            onChange={(e) =>
                                              setData(
                                                data.map(
                                                  (outerItem, outerIndex) => {
                                                    if (outerIndex === index) {
                                                      return {
                                                        ...outerItem,
                                                        menu: outerItem.menu.map(
                                                          (
                                                            innerItem,
                                                            innerIndex
                                                          ) => {
                                                            if (
                                                              innerIndex === idx
                                                            ) {
                                                              return {
                                                                ...innerItem,
                                                                title:
                                                                  e.target
                                                                    .value,
                                                              };
                                                            } else {
                                                              return innerItem;
                                                            }
                                                          }
                                                        ),
                                                      };
                                                    } else {
                                                      return outerItem;
                                                    }
                                                  }
                                                )
                                              )
                                            }
                                          />
                                        ) : (
                                          <p
                                            style={{
                                              margin: 0,
                                              fontSize: 14,
                                              marginBottom: -3,
                                              fontWeight: "500",
                                            }}
                                          >
                                            {item.title}
                                          </p>
                                        )}
                                        {itemEditible.index == index &&
                                          itemEditible.idx == idx ? (
                                          <TextField
                                            sx={{ mb: 1 }}
                                            variant="outlined"
                                            size="small"
                                            inputProps={{
                                              style: { fontSize: 14 },
                                            }}
                                            value={item.description || ""}
                                            onChange={(e) =>
                                              setData(
                                                data.map(
                                                  (outerItem, outerIndex) => {
                                                    if (outerIndex === index) {
                                                      return {
                                                        ...outerItem,
                                                        menu: outerItem.menu.map(
                                                          (
                                                            innerItem,
                                                            innerIndex
                                                          ) => {
                                                            if (
                                                              innerIndex === idx
                                                            ) {
                                                              return {
                                                                ...innerItem,
                                                                description:
                                                                  e.target
                                                                    .value,
                                                              };
                                                            } else {
                                                              return innerItem;
                                                            }
                                                          }
                                                        ),
                                                      };
                                                    } else {
                                                      return outerItem;
                                                    }
                                                  }
                                                )
                                              )
                                            }
                                          />
                                        ) : (
                                          <p
                                            style={{
                                              margin: 0,
                                              fontSize: 12,
                                              marginBottom: -3,
                                              color: "gray",
                                            }}
                                          >
                                            {item.description}
                                          </p>
                                        )}
                                        {itemEditible.index == index &&
                                          itemEditible.idx == idx && (
                                            <TextField
                                              variant="outlined"
                                              size="small"
                                              placeholder="URL"
                                              inputProps={{
                                                style: { fontSize: 14 },
                                              }}
                                              value={item.url || ""}
                                              onChange={(e) =>
                                                setData(
                                                  data.map(
                                                    (outerItem, outerIndex) => {
                                                      if (
                                                        outerIndex === index
                                                      ) {
                                                        return {
                                                          ...outerItem,
                                                          menu: outerItem.menu.map(
                                                            (
                                                              innerItem,
                                                              innerIndex
                                                            ) => {
                                                              if (
                                                                innerIndex ===
                                                                idx
                                                              ) {
                                                                return {
                                                                  ...innerItem,
                                                                  url: e.target
                                                                    .value,
                                                                };
                                                              } else {
                                                                return innerItem;
                                                              }
                                                            }
                                                          ),
                                                        };
                                                      } else {
                                                        return outerItem;
                                                      }
                                                    }
                                                  )
                                                )
                                              }
                                            />
                                          )}
                                      </div>
                                      <div
                                        className="delete-menu-item"
                                        style={{ right: 40 }}
                                      >
                                        {itemEditible.index == index &&
                                          itemEditible.idx == idx ? (
                                          <>
                                            <IconButton
                                              onClick={() =>
                                                doneeditingMenuItem(index, idx)
                                              }
                                              sx={{
                                                color: "green",
                                              }}
                                            >
                                              <DoneIcon fontSize="medium" />
                                            </IconButton>
                                          </>
                                        ) : (
                                          <IconButton
                                            style={{
                                              display: user.perms[3].edit
                                                ? null
                                                : "none",
                                            }}
                                            onClick={() =>
                                              editMenuItem(index, idx)
                                            }
                                            sx={{
                                              color: "grey",
                                              "&:hover": {
                                                color: "#0265d2",
                                              },
                                              transition: "0.3s",
                                            }}
                                          >
                                            <EditIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                        <IconButton
                                          style={{
                                            display: user.perms[3].delete
                                              ? null
                                              : "none",
                                          }}
                                          onClick={() =>
                                            deleteMenuItem(index, idx)
                                          }
                                          sx={{
                                            color: "grey",
                                            "&:hover": {
                                              color: "red",
                                            },
                                            transition: "0.3s",
                                          }}
                                        >
                                          <Delete fontSize="small" />
                                        </IconButton>
                                      </div>
                                      <div className="delete-menu-item">
                                        <IconButton
                                          ref={(el) =>
                                            (subMenuRefs.current[idx] = el)
                                          }
                                          onClick={() => {
                                            toggleSubMenu(idx);
                                            setSubItemEditible({});
                                          }}
                                          sx={{
                                            color: "grey",
                                            "&:hover": {
                                              color: "var(--link)",
                                            },
                                            transition: "0.3s",
                                          }}
                                        >
                                          <ArrowForwardIosIcon fontSize="small" />
                                        </IconButton>

                                        <div
                                          className="sub-menu"
                                          ref={(el) =>
                                            (subMenuRefs.current[idx + 30] = el)
                                          }
                                          style={{
                                            visibility:
                                              openSubMenuIdx === idx
                                                ? "visible"
                                                : "hidden",
                                            opacity:
                                              openSubMenuIdx === idx ? 1 : 0,
                                            width:
                                              openSubMenuIdx === idx ? 430 : 0,
                                          }}
                                        >
                                          <DragDropContext
                                            onDragEnd={(result) =>
                                              onSubDragEnd(result, index, idx)
                                            }
                                          >
                                            <Droppable
                                              droppableId={`menu-${index + 60 * 8
                                                }`}
                                              key={`droppable-${index + 78 * 39
                                                }`}
                                            >
                                              {(provided) => (
                                                <ul
                                                  style={{
                                                    padding: 0,
                                                    marginTop: 0,
                                                    width: "90%",
                                                  }}
                                                  {...provided.droppableProps}
                                                  ref={provided.innerRef}
                                                >
                                                  {data[index]?.menu[
                                                    idx
                                                  ].dropDownItems?.map(
                                                    (item, ndx) => (
                                                      <Draggable
                                                        key={`item-key-${ndx + 403 * 70
                                                          }`}
                                                        draggableId={`item-key-${ndx + 4013 * 8
                                                          }`}
                                                        index={ndx}
                                                      >
                                                        {(provided) => (
                                                          <li
                                                            ref={
                                                              provided.innerRef
                                                            }
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                          >
                                                            <div
                                                              className="menu-b-i"
                                                              style={{
                                                                height:
                                                                  subItemEditible.index ==
                                                                    index &&
                                                                    subItemEditible.idx ==
                                                                    idx &&
                                                                    subItemEditible.ndx ==
                                                                    ndx
                                                                    ? 140
                                                                    : 50,
                                                              }}
                                                            >
                                                              <DragIndicatorIcon
                                                                style={{
                                                                  color: "#777",
                                                                }}
                                                              />
                                                              <div
                                                                className="group relative"
                                                                style={{
                                                                  width:
                                                                    subItemEditible.index ==
                                                                      index &&
                                                                      subItemEditible.idx ==
                                                                      idx &&
                                                                      subItemEditible.ndx ==
                                                                      ndx
                                                                      ? 65
                                                                      : 25,
                                                                  transition:
                                                                    "0.2s",
                                                                }}
                                                                onClick={() => {
                                                                  if (
                                                                    subItemEditible.index ==
                                                                    index &&
                                                                    subItemEditible.idx ==
                                                                    idx &&
                                                                    subItemEditible.ndx ==
                                                                    ndx
                                                                  ) {
                                                                    hiddenFileInput.current.click();
                                                                  }
                                                                }}
                                                              >
                                                                <img
                                                                  style={{
                                                                    width:
                                                                      "100%",
                                                                    aspectRatio: 1,
                                                                    borderRadius: 55,
                                                                    objectFit:
                                                                      "cover",
                                                                    transition:
                                                                      "0.2s",
                                                                  }}
                                                                  src={
                                                                    subItemEditible.index ==
                                                                      index &&
                                                                      subItemEditible.idx ==
                                                                      idx &&
                                                                      subItemEditible.ndx ==
                                                                      ndx
                                                                      ? editibleImage
                                                                        ? URL.createObjectURL(
                                                                          editibleImage
                                                                        )
                                                                        : SERVER_DOMAIN +
                                                                        data[
                                                                          index
                                                                        ]
                                                                          ?.menu[
                                                                          idx
                                                                        ]
                                                                          ?.dropDownItems[
                                                                          ndx
                                                                        ]
                                                                          ?.icon
                                                                      : SERVER_DOMAIN +
                                                                      data[
                                                                        index
                                                                      ]?.menu[
                                                                        idx
                                                                      ]
                                                                        ?.dropDownItems[
                                                                        ndx
                                                                      ]?.icon
                                                                  }
                                                                />

                                                                <div
                                                                  style={{
                                                                    display:
                                                                      subItemEditible.index ==
                                                                        index &&
                                                                        subItemEditible.idx ==
                                                                        idx &&
                                                                        subItemEditible.ndx ==
                                                                        ndx
                                                                        ? "flex"
                                                                        : "none",
                                                                  }}
                                                                  className="group absolute top-0 left-0 w-full rounded-full h-full bg-black bg-opacity-0 hover:bg-opacity-30 transition-opacity flex items-center justify-center"
                                                                >
                                                                  <CameraAltIcon
                                                                    size="small"
                                                                    className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                                                                  />
                                                                </div>
                                                              </div>
                                                              <div>
                                                                {subItemEditible.index ==
                                                                  index &&
                                                                  subItemEditible.idx ==
                                                                  idx &&
                                                                  subItemEditible.ndx ==
                                                                  ndx ? (
                                                                  <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    sx={{
                                                                      mb: 1,
                                                                    }}
                                                                    inputProps={{
                                                                      style: {
                                                                        fontSize: 14,
                                                                      },
                                                                    }}
                                                                    value={
                                                                      item.title ||
                                                                      ""
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      setData(
                                                                        data.map(
                                                                          (
                                                                            outerItem,
                                                                            outerIndex
                                                                          ) => {
                                                                            if (
                                                                              outerIndex ===
                                                                              index
                                                                            ) {
                                                                              return {
                                                                                ...outerItem,
                                                                                menu: outerItem.menu.map(
                                                                                  (
                                                                                    innerItem,
                                                                                    innerIndex
                                                                                  ) => {
                                                                                    if (
                                                                                      innerIndex ===
                                                                                      idx
                                                                                    ) {
                                                                                      return {
                                                                                        ...innerItem,
                                                                                        dropDownItems:
                                                                                          innerItem.dropDownItems.map(
                                                                                            (
                                                                                              nestedItem,
                                                                                              nestedIndex
                                                                                            ) => {
                                                                                              if (
                                                                                                nestedIndex ===
                                                                                                ndx
                                                                                              ) {
                                                                                                return {
                                                                                                  ...nestedItem,
                                                                                                  title:
                                                                                                    e
                                                                                                      .target
                                                                                                      .value,
                                                                                                };
                                                                                              } else {
                                                                                                return nestedItem;
                                                                                              }
                                                                                            }
                                                                                          ),
                                                                                      };
                                                                                    } else {
                                                                                      return innerItem;
                                                                                    }
                                                                                  }
                                                                                ),
                                                                              };
                                                                            } else {
                                                                              return outerItem;
                                                                            }
                                                                          }
                                                                        )
                                                                      )
                                                                    }
                                                                  />
                                                                ) : (
                                                                  <p
                                                                    style={{
                                                                      margin: 0,
                                                                      fontSize: 14,
                                                                      marginBottom:
                                                                        -3,
                                                                      fontWeight:
                                                                        "500",
                                                                    }}
                                                                  >
                                                                    {item.title}
                                                                  </p>
                                                                )}
                                                                {subItemEditible.index ==
                                                                  index &&
                                                                  subItemEditible.idx ==
                                                                  idx &&
                                                                  subItemEditible.ndx ==
                                                                  ndx ? (
                                                                  <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    inputProps={{
                                                                      style: {
                                                                        fontSize: 14,
                                                                      },
                                                                    }}
                                                                    value={
                                                                      item.description ||
                                                                      ""
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) =>
                                                                      setData(
                                                                        data.map(
                                                                          (
                                                                            outerItem,
                                                                            outerIndex
                                                                          ) => {
                                                                            if (
                                                                              outerIndex ===
                                                                              index
                                                                            ) {
                                                                              return {
                                                                                ...outerItem,
                                                                                menu: outerItem.menu.map(
                                                                                  (
                                                                                    innerItem,
                                                                                    innerIndex
                                                                                  ) => {
                                                                                    if (
                                                                                      innerIndex ===
                                                                                      idx
                                                                                    ) {
                                                                                      return {
                                                                                        ...innerItem,
                                                                                        dropDownItems:
                                                                                          innerItem.dropDownItems.map(
                                                                                            (
                                                                                              nestedItem,
                                                                                              nestedIndex
                                                                                            ) => {
                                                                                              if (
                                                                                                nestedIndex ===
                                                                                                ndx
                                                                                              ) {
                                                                                                return {
                                                                                                  ...nestedItem,
                                                                                                  description:
                                                                                                    e
                                                                                                      .target
                                                                                                      .value,
                                                                                                };
                                                                                              } else {
                                                                                                return nestedItem;
                                                                                              }
                                                                                            }
                                                                                          ),
                                                                                      };
                                                                                    } else {
                                                                                      return innerItem;
                                                                                    }
                                                                                  }
                                                                                ),
                                                                              };
                                                                            } else {
                                                                              return outerItem;
                                                                            }
                                                                          }
                                                                        )
                                                                      )
                                                                    }
                                                                  />
                                                                ) : (
                                                                  <p
                                                                    style={{
                                                                      margin: 0,
                                                                      fontSize: 12,
                                                                      marginBottom:
                                                                        -3,
                                                                      color:
                                                                        "gray",
                                                                    }}
                                                                  >
                                                                    {
                                                                      item.description
                                                                    }
                                                                  </p>
                                                                )}

                                                                {subItemEditible.index ==
                                                                  index &&
                                                                  subItemEditible.idx ==
                                                                  idx &&
                                                                  subItemEditible.ndx ==
                                                                  ndx && (
                                                                    <TextField
                                                                      sx={{
                                                                        mt: 1,
                                                                      }}
                                                                      placeholder="URL"
                                                                      variant="outlined"
                                                                      size="small"
                                                                      inputProps={{
                                                                        style: {
                                                                          fontSize: 14,
                                                                        },
                                                                      }}
                                                                      value={
                                                                        item.url ||
                                                                        ""
                                                                      }
                                                                      onChange={(
                                                                        e
                                                                      ) =>
                                                                        setData(
                                                                          data.map(
                                                                            (
                                                                              outerItem,
                                                                              outerIndex
                                                                            ) => {
                                                                              if (
                                                                                outerIndex ===
                                                                                index
                                                                              ) {
                                                                                return {
                                                                                  ...outerItem,
                                                                                  menu: outerItem.menu.map(
                                                                                    (
                                                                                      innerItem,
                                                                                      innerIndex
                                                                                    ) => {
                                                                                      if (
                                                                                        innerIndex ===
                                                                                        idx
                                                                                      ) {
                                                                                        return {
                                                                                          ...innerItem,
                                                                                          dropDownItems:
                                                                                            innerItem.dropDownItems.map(
                                                                                              (
                                                                                                nestedItem,
                                                                                                nestedIndex
                                                                                              ) => {
                                                                                                if (
                                                                                                  nestedIndex ===
                                                                                                  ndx
                                                                                                ) {
                                                                                                  return {
                                                                                                    ...nestedItem,
                                                                                                    url: e
                                                                                                      .target
                                                                                                      .value,
                                                                                                  };
                                                                                                } else {
                                                                                                  return nestedItem;
                                                                                                }
                                                                                              }
                                                                                            ),
                                                                                        };
                                                                                      } else {
                                                                                        return innerItem;
                                                                                      }
                                                                                    }
                                                                                  ),
                                                                                };
                                                                              } else {
                                                                                return outerItem;
                                                                              }
                                                                            }
                                                                          )
                                                                        )
                                                                      }
                                                                    />
                                                                  )}
                                                              </div>
                                                              <div
                                                                className="delete-menu-item"
                                                                style={{
                                                                  right: 10,
                                                                }}
                                                              >
                                                                {subItemEditible.index ==
                                                                  index &&
                                                                  subItemEditible.idx ==
                                                                  idx &&
                                                                  subItemEditible.ndx ==
                                                                  ndx ? (
                                                                  <>
                                                                    <IconButton
                                                                      onClick={() =>
                                                                        doneeditingMenuSubItem(
                                                                          index,
                                                                          idx,
                                                                          ndx
                                                                        )
                                                                      }
                                                                      sx={{
                                                                        color:
                                                                          "green",
                                                                      }}
                                                                    >
                                                                      <DoneIcon fontSize="medium" />
                                                                    </IconButton>
                                                                  </>
                                                                ) : (
                                                                  <IconButton
                                                                    style={{
                                                                      display:
                                                                        user
                                                                          .perms[3]
                                                                          .edit
                                                                          ? null
                                                                          : "none",
                                                                    }}
                                                                    onClick={() =>
                                                                      editSubMenuItem(
                                                                        index,
                                                                        idx,
                                                                        ndx
                                                                      )
                                                                    }
                                                                    sx={{
                                                                      color:
                                                                        "grey",
                                                                      "&:hover":
                                                                      {
                                                                        color:
                                                                          "#0265d2",
                                                                      },
                                                                      transition:
                                                                        "0.3s",
                                                                    }}
                                                                  >
                                                                    <EditIcon fontSize="small" />
                                                                  </IconButton>
                                                                )}
                                                                <IconButton
                                                                  style={{
                                                                    display:
                                                                      user
                                                                        .perms[3]
                                                                        .delete
                                                                        ? null
                                                                        : "none",
                                                                  }}
                                                                  onClick={() =>
                                                                    deleteSubMenuItem(
                                                                      index,
                                                                      idx,
                                                                      ndx
                                                                    )
                                                                  }
                                                                  sx={{
                                                                    color:
                                                                      "grey",
                                                                    "&:hover": {
                                                                      color:
                                                                        "red",
                                                                    },
                                                                    transition:
                                                                      "0.3s",
                                                                  }}
                                                                >
                                                                  <Delete fontSize="small" />
                                                                </IconButton>
                                                              </div>
                                                            </div>
                                                          </li>
                                                        )}
                                                      </Draggable>
                                                    )
                                                  )}
                                                  {provided.placeholder}
                                                </ul>
                                              )}
                                            </Droppable>
                                          </DragDropContext>

                                          <div
                                            style={{
                                              opacity: subOpenAdd[index]?.open
                                                ? 1
                                                : 0,
                                              height: subOpenAdd[index]?.open
                                                ? 175
                                                : 0,
                                              marginBottom: subOpenAdd[index]
                                                ?.open
                                                ? 10
                                                : 0,
                                              visibility: subOpenAdd[index]
                                                ?.open
                                                ? "visible"
                                                : "hidden",
                                              transition: "0.3s",
                                              display: "flex",
                                              alignItems: "center",
                                              flexDirection: "column",
                                              gap: 10,
                                              width: "90%",
                                              paddingTop: 5,
                                            }}
                                          >
                                            <TextField

                                              sx={{ width: "90%" }}
                                              label="Tilte"
                                              variant="outlined"
                                              size="small"
                                              value={
                                                subInputV[index]?.title || ""
                                              }
                                              error={errors[index]?.error}
                                              onChange={(e) => {
                                                setSubInputV([
                                                  ...subInputV.map(
                                                    (item, idx) => {
                                                      if (idx === index) {
                                                        return {
                                                          ...item,
                                                          title: e.target.value,
                                                        };
                                                      } else {
                                                        return item;
                                                      }
                                                    }
                                                  ),
                                                ]);
                                              }}
                                            />
                                            <TextField

                                              sx={{ width: "90%" }}
                                              label="Description"
                                              variant="outlined"
                                              size="small"
                                              value={
                                                subInputV[index]?.description ||
                                                ""
                                              }
                                              error={errors[index]?.error}
                                              onChange={(e) => {
                                                setSubInputV([
                                                  ...subInputV.map(
                                                    (item, idx) => {
                                                      if (idx === index) {
                                                        return {
                                                          ...item,
                                                          description:
                                                            e.target.value,
                                                        };
                                                      } else {
                                                        return item;
                                                      }
                                                    }
                                                  ),
                                                ]);
                                              }}
                                            />
                                            <TextField

                                              sx={{ width: "90%" }}
                                              label="URL"
                                              variant="outlined"
                                              size="small"
                                              value={
                                                subInputV[index]?.url || ""
                                              }
                                              error={errors[index]?.error}
                                              onChange={(e) => {
                                                setSubInputV([
                                                  ...subInputV.map(
                                                    (item, idx) => {
                                                      if (idx === index) {
                                                        return {
                                                          ...item,
                                                          url: e.target.value,
                                                        };
                                                      } else {
                                                        return item;
                                                      }
                                                    }
                                                  ),
                                                ]);
                                              }}
                                            />
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 7,
                                                marginTop: 3,
                                                width: "90%",
                                              }}
                                            >
                                              <p
                                                style={{
                                                  margin: 0,
                                                  color: "grey",
                                                }}
                                              >
                                                Icon
                                              </p>
                                              <img
                                                style={{
                                                  width: 25,
                                                  aspectRatio: 1,
                                                  borderRadius: 50,
                                                  objectFit: "cover",
                                                }}
                                                src={
                                                  subInputV[index]?.icon
                                                    ? URL.createObjectURL(
                                                      subInputV[index]?.icon
                                                    )
                                                    : require("../assets/placeholder-image.png")
                                                }
                                              />
                                              <input
                                                ref={fileInputRef}
                                                type="file"
                                                accept="image/*"
                                                onChange={(e) =>
                                                  handleSubIconInput(e, index)
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div
                                            onClick={() => {
                                              if (
                                                subOpenAdd[index]?.open == false
                                              ) {
                                                setSubOpenAdd([
                                                  ...subOpenAdd.map(
                                                    (item, idx) => {
                                                      if (idx === index) {
                                                        return {
                                                          ...item,
                                                          open: true,
                                                        };
                                                      } else {
                                                        return item;
                                                      }
                                                    }
                                                  ),
                                                ]);
                                              } else {
                                                if (
                                                  subInputV[index]?.title !==
                                                  "" &&
                                                  subInputV[index]
                                                    ?.description !== "" &&
                                                  subInputV[index]?.icon !== ""
                                                ) {
                                                  addNewSubMenuItem(index, idx);
                                                } else {
                                                  setSubOpenAdd([
                                                    ...subOpenAdd.map(
                                                      (item, idx) => {
                                                        if (idx === index) {
                                                          return {
                                                            ...item,
                                                            open: false,
                                                          };
                                                        } else {
                                                          return item;
                                                        }
                                                      }
                                                    ),
                                                  ]);
                                                }
                                              }
                                            }}
                                            className="submitBTN"
                                            style={{
                                              display: user.perms[3].add
                                                ? null
                                                : "none",
                                              gap: 7,
                                              fontSize: 15,
                                              height: 40,
                                              marginTop: 0,
                                              backgroundColor: subOpenAdd[index]
                                                ?.open
                                                ? subInputV[index]?.title ==
                                                  "" ||
                                                  subInputV[index]
                                                    ?.description == "" ||
                                                  subInputV[index]?.icon == ""
                                                  ? "red"
                                                  : "var(--link)"
                                                : "var(--link)",
                                            }}
                                          >
                                            {subOpenAdd[index]?.open
                                              ? subInputV[index]?.title == "" ||
                                                subInputV[index]?.description ==
                                                "" ||
                                                subInputV[index]?.icon == ""
                                                ? "Cancel"
                                                : "Submit"
                                              : "Add New"}
                                            {subOpenAdd[index]?.open ? (
                                              ""
                                            ) : (
                                              <AddCircleOutlineRounded
                                                style={{ fontSize: 22 }}
                                              />
                                            )}
                                          </div>
                                          <div
                                            style={{
                                              height: 32,
                                              width: "60%",
                                              marginTop: 2,
                                            }}
                                            className="cancelBTN"
                                            onClick={() => {
                                              setOpenSubMenuIdx(null);
                                              setSubItemEditible({});
                                            }}
                                          >
                                            Close
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </ul>
                        )}
                      </Droppable>
                    </DragDropContext>
                    <div
                      style={{
                        opacity: openAdd[index]?.open ? 1 : 0,
                        height: openAdd[index]?.open ? 170 : 0,
                        marginBottom: openAdd[index]?.open ? 10 : 0,
                        visibility: openAdd[index]?.open ? "visible" : "hidden",
                        transition: "0.3s",
                        display: "flex",
                        flexDirection: "column",
                        gap: 8,
                        marginTop: 10,
                      }}
                    >
                      <TextField

                        sx={{ width: "35%" }}
                        label="Tilte"
                        variant="outlined"
                        size="small"
                        value={inputV[index]?.title || ""}
                        onChange={(e) => {
                          setInputV([
                            ...inputV.map((item, idx) => {
                              if (idx === index) {
                                return { ...item, title: e.target.value };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />
                      <TextField

                        sx={{ width: "35%" }}
                        label="Description"
                        variant="outlined"
                        size="small"
                        value={inputV[index]?.description || ""}
                        onChange={(e) => {
                          setInputV([
                            ...inputV.map((item, idx) => {
                              if (idx === index) {
                                return { ...item, description: e.target.value };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />
                      <TextField

                        sx={{ width: "35%" }}
                        label="URL"
                        variant="outlined"
                        size="small"
                        value={inputV[index]?.url || ""}
                        onChange={(e) => {
                          setInputV([
                            ...inputV.map((item, idx) => {
                              if (idx === index) {
                                return { ...item, url: e.target.value };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 7,
                          marginTop: 3,
                          width: "90%",
                        }}
                      >
                        <p
                          style={{
                            margin: 0,
                            color: "grey",
                          }}
                        >
                          Icon
                        </p>
                        <img
                          style={{
                            width: 25,
                            aspectRatio: 1,
                            borderRadius: 50,
                            objectFit: "cover",
                          }}
                          src={
                            inputV[index]?.icon
                              ? URL.createObjectURL(inputV[index]?.icon)
                              : require("../assets/placeholder-image.png")
                          }
                        />
                        <input
                          ref={fileInputRef}
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleIconInput(e, index)}
                        />
                      </div>
                    </div>
                    <div
                      className="submitBTN"
                      style={{
                        display: user.perms[3].add ? null : "none",
                        width: "35%",
                        fontSize: 15,
                        height: 40,
                        gap: 7,
                        borderRadius: 7,
                        marginTop: 15,
                        backgroundColor: openAdd[index]?.open
                          ? inputV[index]?.title == "" ||
                            inputV[index]?.description == "" ||
                            inputV[index]?.icon == ""
                            ? "red"
                            : "var(--link)"
                          : "var(--link)",
                      }}
                      onClick={() => {
                        if (openAdd[index]?.open == false) {
                          setOpenAdd([
                            ...openAdd.map((item, idx) => {
                              if (idx === index) {
                                return { ...item, open: true };
                              } else {
                                return item;
                              }
                            }),
                          ]);
                        } else {
                          if (
                            inputV[index]?.title !== "" &&
                            inputV[index]?.description !== "" &&
                            inputV[index]?.icon !== ""
                          ) {
                            addNewMenuItem(index);
                          } else {
                            setOpenAdd([
                              ...openAdd.map((item, idx) => {
                                if (idx === index) {
                                  return { ...item, open: false };
                                } else {
                                  return item;
                                }
                              }),
                            ]);
                          }
                        }
                      }}
                    >
                      {openAdd[index]?.open
                        ? inputV[index]?.title == "" ||
                          inputV[index]?.description == "" ||
                          inputV[index]?.icon == ""
                          ? "Cancel"
                          : "Submit"
                        : "Add New"}
                      {openAdd[index]?.open ? (
                        ""
                      ) : (
                        <AddCircleOutlineRounded style={{ fontSize: 22 }} />
                      )}
                    </div>
                  </div>
                  <div
                    className="submitBTN"
                    onClick={() => submitData(item, index)}
                    style={{ display: user.perms[3].edit ? null : "none" }}
                  >
                    Save Changes
                  </div>

                  {Object.keys(itemEditible).length > 0 ||
                    Object.keys(subItemEditible).length > 0 ? (
                    <div
                      className="flex items-center content-center w-[350px] h-10 bg-red-500  mt-3 text-white rounded-md cursor-pointer hover:bg-red-600"
                      onClick={() => {
                        setItemEditible({});
                        setSubItemEditible({});
                      }}
                    >
                      Cancel Editing
                    </div>
                  ) : null}
                </TabPanel>
              );
            })}
          </>
        )}
        <input
          type="file"
          accept="image/png, image/jpeg"
          onChange={handleImageChange}
          ref={hiddenFileInput}
          style={{ display: "none" }}
        />
      </Box>
    </TabContext>
  );
}
